import { VariantProps, cva } from 'class-variance-authority';

import { LogoShort as LogoShortIcon, Logo as LogoIcon } from '../icons';
import { cn } from '../../utils';

const logoVariants = cva('inline-block h-auto text-surface', {
  variants: {
    size: {
      small: 'h-8',
      large: 'h-14',
    },
  },
  defaultVariants: {
    size: 'small',
  },
});

export interface LogoProps extends VariantProps<typeof logoVariants> {
  className?: string;
  short?: boolean;
}

function Logo({ size, className, short }: LogoProps) {
  return short ? (
    <LogoShortIcon className={cn(logoVariants({ size }), className)} />
  ) : (
    <LogoIcon className={cn(logoVariants({ size }), className)} />
  );
}

export { logoVariants, Logo };
